import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { toast, loading } from '@/shared/utils/UIHelper'
import Datepicker from 'vuejs-datepicker'
import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import EmployeeBoardRepository from '@/shared/http/repositories/business/employeeboard.js'
import SectionRHRepository from '@/shared/http/repositories/business/sectionrh.js'
import EmployeeBoardSearchForm from './search-form.js'
import EmployeeBoardSearchData from '@/shared/models/business/employeeboardsearchmodel.js'
import boardMixin from '../mixins/BoardMixin.js'

export default {
  name: 'employeeboardsearch',
  mixins: [ ActionsForm, boardMixin ],
  data () {
    return {
      data: EmployeeBoardSearchData,
      form: EmployeeBoardSearchForm,
      en: en,
      es: es,
      ptBR: ptBR,
      cbxSelected: []
    }
  },
  components: {
    Datepicker,
    AutocompleteZ
  },
  created () {
    this.onLoadAllSections()
  },
  methods: {
    onLoad () {
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      this.$refs.obraRHTypeahead.clear()
      this.$refs.clienteRHTypeahead.clear()
      this.$refs.tableGrid.Clear()
    },
    onClickSearch () {
      this.$refs.tableGrid.pagingIndex = 1
      this.onSearch()
    },
    onSearch () {
      if (Tools.ValidateForms(this.form, this.data, self, toast)) {
        loading.push()
        EmployeeBoardRepository.Search(this.CompanySelected, this.data, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
      }
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDeleteBoard (obj) {
      this.$emit('Delete', obj)
    },
    onLoadAllSections () {
      loading.push()
      SectionRHRepository.GetAll(this.CompanySelected)
        .then((response) => {
          if (response.data.code > 0) {
            this.form.secaoRHID.options = this.onResultDropdown(response, null, f => f.codigo + ' - ' + f.nome)
          }
          loading.close()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onClearSection () {
      this.form.secaoRH.value = ''
    },
    onChangeCodeSection (value) {
      var options = this.form.secaoRHID.options
      this.form.secaoRHID.value = ''
      for (var i in options) {
        var names = options[i].text.split('-')
        if (names[0].trim().toUpperCase() === value.toUpperCase()) {
          this.form.secaoRHID.value = options[i].value
        }
      }
    },
    onFullscreen () {
      if (this.$refs.frmSearch.showForm) {
        this.$refs.frmSearch.showForm = false
      } else {
        this.$refs.frmSearch.showForm = true
      }
    },
    onDownload () {
      if (this.objList) {
        loading.push()
        this.objList.forEach(e => {
          if (e.checked) {
            if (!this.cbxSelected.find(x => x.id === e.id)) {
              this.cbxSelected.push(e)
            }
          }
        })

        if (this.cbxSelected.length > 0) {
          setTimeout(function () { loading.close() }, 3000)
          // TODO: implement download from back
        } else {
          toast.warning(this.$lang.EmployeeBoard.Search.DownloadWarning)
          setTimeout(function () { loading.close() }, 1000)
        }
      } else {
        toast.warning(this.$lang.EmployeeBoard.Search.DownloadWarning)
      }
    },
    onPrint () {
      loading.push()
      const objSelected = this.objList.filter(e => e.checked).map(e => e.id)

      if (objSelected.length > 0) {
        EmployeeBoardRepository.Print(objSelected)
          .then((response) => {
            if (response.data.code > 0) {
              let pdfWindow = window.open('Quadro.pdf')
              let pdf = encodeURI(response.data.data)
              pdfWindow.document.write(`
                <embed width="100%" height="100%" src="data:application/pdf;base64,${pdf}"></embed>
              `)
            }
          })
          .catch(this.onException)
      }

      loading.close()
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/private/finance/employeeboard/search/search.js